import * as React from "react";
import {observer} from "mobx-react";
import {withAppStores} from "../../../../../../../AppStores";
import {Field} from "../../../../../../widgets/form/field/Field";
import type {AppState} from "../../../../../../../data/state/AppState";
import {IDateFieldFormat} from "../../../../../settings/modules/field/datatypes/DateFieldSettings";
import type {Markup} from "../../../../../../../data/models/Markup";
import {DateFormatter} from "../../../../../../../utils/format/DateFormatter";
import {SelectInput} from "../../../../../../widgets/input/select/SelectInput";
import {changeMarkupType, markupTypeToMarkupToolName} from "../../../../../space/spaceeditor/logic3d/elements3d/markups/abstract/MarkupUtils";
import {MarkupType} from "../../../../../../../generated/api/base";
import {SVGIcon} from "../../../../../../widgets/button/SVGIcon";
import {MarkupsWithInterchangeableProperties} from "../../../../../space/spaceeditor/logic3d/elements3d/markups/MarkupStaticElements";
import {zIndex} from "../../../../../../5.0/styles/styles";
import type {SpaceViewRenderer} from "../../../../../space/spaceeditor/logic3d/renderers/SpaceViewRenderer";

interface IMarkupDefaultFieldsProps {
	readonly item: Markup;
	readonly appState?: AppState;
}

@withAppStores("appState")
@observer
export class MarkupDefaultFields extends React.Component<IMarkupDefaultFieldsProps> {
	private _spaceViewRenderer: SpaceViewRenderer = this.props.appState.app.graphicalTools.spaceViewRenderer;

	private onMarkupTypeChange = (markupType: MarkupType) => {
		changeMarkupType([this.props.item], markupType, this._spaceViewRenderer);
	};

	private markupTypeRender = (markupType: MarkupType) => {
		const formattedMarkupType = `${MarkupType[markupType].replaceAll("_", " ")} Markup`;

		const tools = this._spaceViewRenderer.tools;
		const icon = (
			<SVGIcon
				icon={tools[markupTypeToMarkupToolName(markupType)].icon}
				style={{width: "24px", height: "24px", marginRight: "10px", fill: "initial"}}
			/>
		);

		return (
			<div className="hbox alignCenter">
				{icon}
				{formattedMarkupType}
			</div>
		);
	};

	public override componentDidUpdate(prevProps: Readonly<IMarkupDefaultFieldsProps>, prevState: Readonly<{}>, snapshot?: any): void {
		if (this.props.appState.app.graphicalTools.spaceViewRenderer !== this._spaceViewRenderer) {
			this._spaceViewRenderer = this.props.appState.app.graphicalTools.spaceViewRenderer;
		}
	}

	public override render() {
		const {item, appState} = this.props;
		const {isTypeChangeable} = item;

		return (
			<>
				<Field label="Markup Type">
					{isTypeChangeable ? (
						<SelectInput
							options={MarkupsWithInterchangeableProperties}
							selected={item.type}
							render={this.markupTypeRender}
							onChange={this.onMarkupTypeChange}
							optionsZIndex={zIndex.anchoredHeader + 1}
						/>
					) : (
						item.typeName
					)}
				</Field>
				<Field label="Last Modified At">{DateFormatter.format(item.data.lastModifiedAt, IDateFieldFormat.DATETIME)}</Field>
				<Field label="Last Modified By">{appState.actions.findUser(item.data.lastModifiedBy)?.fullName || ""}</Field>
			</>
		);
	}
}
